import $ from 'jquery';
import 'slick-carousel';

const satisfactionForm = () => {
    const $elForm = $('.js-satisfaction');
    if ($elForm.length === 0) {
        return;
    }
    const $elQuestions = $('.js-satisfaction-question');
    const $elQuestionsRequired = $elQuestions.filter('[data-required="true"]');
    const $elInputs = $('input[required]', $elQuestionsRequired);
    const $elProgression = $('.js-satisfaction-progression');
    const $elNext = $('.js-satisfaction-next');

    let prevStep = -1;
    let currentStep = 0;

    function init () {
        onResize();

        // Disable all next buttons
        checkQuestionsValid();

        attachEvents();
        detectCurrentStep();
    }

    function attachEvents () {
        $elInputs.on('change', checkQuestionsValid);
        $(window).on('scroll', detectCurrentStep);
        $(window).on('resize', onResize);

        // Check if browser doesn't supports smooth scroll behavior
        if (!('scrollBehavior' in document.documentElement.style)) {
            $elNext.on('click', function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $($(this).attr('href')).offset().top
                }, 500);
            })
        }
    }

    function checkQuestionsValid () {
        $elQuestionsRequired.each((index, elQuestion) => {
            const $elInputsChecked = $('input:checked', elQuestion);
            if ($elInputsChecked.length > 0) {
                $('.js-satisfaction-next', elQuestion).removeClass('is-disabled');
            } else {
                $('.js-satisfaction-next', elQuestion).addClass('is-disabled');
            }
        });
    }

    function onResize () {
        $elQuestions.each((i, elQuestion) => {
            elQuestion._offsetTop = $(elQuestion).offset().top;
        });
    }

    // Detect visible step on scroll
    function detectCurrentStep () {
        const scrollTop = $(window).scrollTop();
        const wh = $(window).height();
        currentStep = -1;
        $elQuestions.each((i, elQuestion) => {
            if (elQuestion._offsetTop - scrollTop - wh < 0) {
                currentStep = i;
            }
        });

        if (currentStep !== prevStep) {
            $elProgression.find('.js-satisfaction-progression-step').eq(prevStep).removeClass('is-active');
            if (currentStep >= 0) {
                $elProgression.find('.js-satisfaction-progression-step').eq(currentStep).addClass('is-active');
            }
            prevStep = currentStep;
        }
    }

    init();
};

export default satisfactionForm();
